import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';

const ItemQuantityCost = ({
  quantity,
  cost,
}: {
  quantity: number;
  cost: number;
}) => {
  return (
    <div className="sui-flex sui-flex-col sui-gap-[4px] sui-flex-grow sui-ml-auto sui-text-right">
      <Typography height="tight">Qty: {quantity}</Typography>
      <Typography weight="bold" height="tight">
        ${(cost * quantity).toFixed(2)}
      </Typography>
    </div>
  );
};

export default ItemQuantityCost;
